import className from 'classnames/bind';
import styles from './PostsCarousel.module.scss';
import { Carousel, Container, PostsEntry } from '@/components';

let cx = className.bind(styles);

export function PostsCarousel({ posts, title }) {
	return (
		<section className={cx(['ns_post-carousel', 'post-carousel'])}>
			<Container>
				{title && <h2 className={cx(['ns_post-carousel-title', 'post-carousel-title'])}>{title}</h2>}
				<Carousel previousNextControls={true} slidesDisplayed={3} className={cx('carousel')}>
					{posts?.edges?.map((post) => (
						<div key={post.node.id} className={cx(['ns_slide', 'slide'])}>
							<PostsEntry title={post.node.title} date={post.node.date} author={post.node.author} uri={post.node.uri} featuredImage={post.node.featuredImage} articleHeadingStyle='is-style-heading-body' imageSizes='(max-width: 500px) 100vw, (max-width: 820px) 350px, (max-width: 1600px) 33vw, 410px' />
						</div>
					))}
				</Carousel>
			</Container>
		</section>
	);
}
